import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import './LegacyGroupRedirectPage.css';

/**
 * Страница /group — редирект со старых URL вида /group/?96929978.
 * Берёт старый ID группы из адресной строки, запрашивает новый id по legacy_group_id и перенаправляет на /g/:id.
 */
const LegacyGroupRedirectPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading'); // 'loading' | 'redirect' | 'error'

    useEffect(() => {
        // Старый сайт: /group/?96929978 — число может быть единственным параметром (имя параметра без значения)
        const legacyIdFromId = searchParams.get('id') || searchParams.get('legacy_id');
        const keys = [...searchParams.keys()];
        const legacyIdFromKey = keys.find(k => k && /^\d+$/.test(k)) || (keys[0] || '').trim();
        const legacyId = (legacyIdFromId || legacyIdFromKey || '').toString().trim();

        if (!legacyId) {
            setStatus('error');
            return;
        }

        axios.get(`${API_BASE_URL}/groups/by-legacy-id`, {
            params: { legacy_id: legacyId }
        })
            .then(res => {
                const newId = res.data?.id;
                if (newId != null) {
                    setStatus('redirect');
                    navigate(`/g/${newId}`, { replace: true });
                } else {
                    setStatus('error');
                }
            })
            .catch(() => setStatus('error'));
    }, [searchParams, navigate]);

    if (status === 'error') {
        return (
            <div className="legacy-redirect-page">
                <div className="legacy-redirect-card">
                    <h2>Группа не найдена</h2>
                    <p>Ссылка устарела или группа не существует.</p>
                    <button type="button" className="btn btn-primary" onClick={() => navigate('/public/groups', { replace: true })}>
                        Перейти к списку групп
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="legacy-redirect-page">
            <div className="legacy-redirect-card">
                <div className="spinner" />
                <p>Перенаправление…</p>
            </div>
        </div>
    );
};

export default LegacyGroupRedirectPage;
